export default __webpack_public_path__ + "static/media/logo-renta-sm.8ef01a34.svg";